import { useCallback, useEffect, useRef } from "react";

/**
 * Long press = start of «select several» (Света 04.11: вместо колонки галочек «Выбор» — зажатие).
 * bind(item) gives pointer handlers for a row; a long press calls onLongPress(item) and swallows
 * the click that follows, so the card does not open. Чат 4, правка №15, доработка 5. [Claude] 2026-11-04
 */
export const LONG_PRESS_MS = 450;
const INTERACTIVE = "button, a, input, textarea, select, label";

export default function useLongPress(onLongPress, { delay = LONG_PRESS_MS } = {}) {
    const timer = useRef(null);
    const fired = useRef(false);
    const start = useRef(null);

    const cancel = useCallback(() => {
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = null;
        }
    }, []);

    useEffect(() => cancel, [cancel]);

    return useCallback((item) => ({
        onPointerDown: (event) => {
            if (event.button !== undefined && event.button !== 0) return;
            if (event.target?.closest?.(INTERACTIVE)) return;
            fired.current = false;
            start.current = { x: event.clientX || 0, y: event.clientY || 0 };
            cancel();
            timer.current = setTimeout(() => {
                timer.current = null;
                fired.current = true;
                onLongPress(item);
            }, delay);
        },
        onPointerMove: (event) => {
            if (!timer.current || !start.current) return;
            if (Math.abs((event.clientX || 0) - start.current.x) > 8 || Math.abs((event.clientY || 0) - start.current.y) > 8) cancel();
        },
        onPointerUp: cancel,
        onPointerLeave: cancel,
        onPointerCancel: cancel,
        onClickCapture: (event) => {
            if (fired.current) {
                fired.current = false;
                event.preventDefault();
                event.stopPropagation();
            }
        },
        onContextMenu: (event) => { if (fired.current || timer.current) event.preventDefault(); },
    }), [onLongPress, delay, cancel]);
}
